import Touchable, { TouchableProps } from '@sport1/react-elements/Touchable'

export type MinifiedTouchableProps = Pick<
    TouchableProps,
    'onPress' | 'href' | 'onLongPress' | 'webTarget' | 'webRel'
>

export default Touchable
